import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterEvent,
} from '@angular/router';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { UserService } from 'src/app/core/services/user.service';
import { ICase } from '../../interfaces/case.interface';
import { Subscription } from 'rxjs';
import { CaseService } from 'src/app/modules/case/services/case.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ConfirmComponent } from 'src/app/components/shared/components/confirm/confirm.component';
import { RemitCaseComponent } from '../remit-case/remit-case.component';
import { GenerateTasksComponent } from 'src/app/modules/case/components/generate-tasks/generate-tasks.component';
import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FinishCaseComponent } from '../finishCase/finishCase.component';
import { RasNumberComponent } from 'src/app/components/shared/components/ras-number/ras-number.component';
import { ProceedCaseComponent } from '../proceed-case/proceed-case.component';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import { SocketService } from 'src/app/core/services/socket.service';
import { CasesContentNewViewComponent } from '../cases-content-new-view/cases-content-new-view.component';
import { CreateBtCaseComponent } from '../create-bt-case/create-bt-case.component';

@Component({
  selector: 'alert-content',
  templateUrl: './alert-content.component.html',
  styleUrls: ['./alert-content.component.scss'],
})
export class AlertContentComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild(CasesContentNewViewComponent)
  casesContentNewViewComponent: CasesContentNewViewComponent;
  unitId!: string;
  displayedColumns: string[] = [
    'options',
    'gai',
    'description',
    'creator',
    'createdAt',
  ];
  dataSource: MatTableDataSource<any>;

  status = {
    initial: 'Abierto',
    proceed: 'Asignado',
    refused: 'Rechazado',
    archived: 'Archivado',
    pending: 'Pendiente',
  };
  allAlertsAbierto = [];
  allAlertsAsignado = [];
  allAlertsRechazado = [];
  shirley: any;
  loading = false;
  unitinfo = null;

  routerSuscription: Subscription;
  constructor(
    //  private readonly casesService: CasesService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    public userService: UserService,
    private readonly dialog: MatDialog,
    private readonly caseService: CaseService,
    private readonly unitService: UnitsService,
    private _snackBar: MatSnackBar,
    private readonly alertService: AlertService,
    private socket: SocketService
  ) {
    this.routerSuscription = this.router.events.subscribe(
      async (event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          this.unitId = route.snapshot.paramMap.get('id');
          this.reset();
          this.update();
          this.socketOn();
        }
      }
    );
    this.unitId = route.snapshot.paramMap.get('id');
  }
  ngOnDestroy(): void {
    this.routerSuscription?.unsubscribe();
  }

  socketOn() {
    this.socket.socket.on('new-alert', async (msj: { ok: boolean }) => {
      console.log('MessageReceived!', msj);
      this.update();
    });
  }

  setData(alert: any[]) {
    this.dataSource = new MatTableDataSource(alert);
    this.dataSource.paginator = this.paginator;
  }

  proceedCase(alert) {
    this.dialog
      .open(ProceedCaseComponent, {
        width: '700px',
        maxHeight: '80vh',
        data: {
          unit: this.unitId,
          alert: alert,
        },
      })
      .afterClosed()
      .subscribe({
        next: (alertUpdated: any) => {
          if (alertUpdated) {
            if (alertUpdated.status == 'refused') {
              let index = this.allAlertsRechazado.findIndex(
                (item) => item._id == alertUpdated._id
              );
              this.allAlertsRechazado.splice(index, 1, alertUpdated);
              this.setData(this.allAlertsRechazado);
            } else if (alertUpdated.status == 'proceed') {
              let index = this.allAlertsAsignado.findIndex(
                (item) => item._id == alertUpdated._id
              );
              this.allAlertsAsignado.splice(index, 1);
              this.setData(this.allAlertsAsignado);
            }
            this.casesContentNewViewComponent.table.renderRows();
          }
        },
      });
  }
  edit(icase) {}
  durationInSeconds = 4;
  openSnackBar(alert) {}
  async delete(icase) {
    let response = await this.confirm('¿Seguro deseas eliminar este caso?');
    if (response) {
      this.openSnackBar(icase);
    }
  }
  async seeCase(alert, status, a = undefined, b = undefined) {
    this.router.navigate([`/alertInfo/${alert._id}`]);
  }
  confirm(message) {
    return new Promise((resolve) => {
      this.dialog
        .open(ConfirmComponent, {
          data: {
            title: message,
          },
        })
        .afterClosed()
        .subscribe({ next: (result) => resolve(result) });
    });
  }
  alert(message) {
    this.dialog.open(SuccessComponent, { data: { title: message } });
  }
  get canMove() {
    return this.userService.permissions.changeColumnCases;
  }

  update() {
    console.log('Updating alertas');
    this.getAlertByFilterAbierto();
    this.getAlertByFilterAsignado();
    this.getAlertByFilterRechazado();
    this.getCaseTypes();
  }

  ngOnInit() {
    this.shirley = this.userService.currentUser.username;
    console.log('Shirley: ', this.shirley);
    this.alertService.filterDataAlert.subscribe({
      next: (filter) => {
        delete filter.caseType;
        this.getAlertByFilterAbierto(filter);
        this.getAlertByFilterAsignado(filter);
        this.getAlertByFilterRechazado(filter);
      },
    });

    this.alertService.alertCreated.subscribe({
      next: (newCase) => {
        this.allAlertsAbierto.unshift(newCase);

        this.setData(this.allAlertsAbierto);
      },
    });
    // this.alertService.alertImportedVu.subscribe({
    //   next: (newCases) => {
    //     this.initial = [...this.initial, ...newCases];
    //     this.allAlertsAbierto = [...this.allAlertsAbierto, ...newCases];
    //     if (this.valueTab == 0) {
    //       this.setData(this.allAlertsAbierto);
    //       this.table.renderRows();
    //     }
    //   },
    // });
    this.alertService.alertEdited.subscribe({
      next: (caseEdited) => {
        let index = 0;
        switch (caseEdited.status) {
          case 'tobeApproved':
            index = this.tobeApproved.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.tobeApproved.splice(index, 1, caseEdited);
            break;
          case 'toFinalize':
            index = this.toFinalize.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.toFinalize.splice(index, 1, caseEdited);
            break;
          case 'running':
            index = this.running.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.running.splice(index, 1, caseEdited);
            break;
          case 'initial':
            index = this.initial.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.initial.splice(index, 1, caseEdited);
            break;
          case 'pending':
            index = this.pending.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.pending.splice(index, 1, caseEdited);
            break;
          default:
            console.log('Error');
            break;
        }
      },
    });

    this.alertService.filterDataSearch.subscribe({
      next: (filters) => {
        this.getAlertByFilterAbierto(filters);
        this.getAlertByFilterAsignado(filters);
        this.getAlertByFilterRechazado(filters);
      },
    });
  }

  reset() {
    const types = [
      'initial',
      'toFinalize',
      'tobeApproved',
      'running',
      'pending',
    ]; // TODO adding pending
    for (const key of types) {
      this[key] = [];
    }

    switch (this.valueTab) {
      case 0:
        this.allAlertsAbierto = [];
        this.setData(this.allAlertsAbierto);
        break;
      case 1:
        this.allAlertsAsignado = [];
        this.setData(this.allAlertsAsignado);
        break;
      case 2:
        this.allAlertsRechazado = [];
        this.setData(this.allAlertsRechazado);
        break;

      default:
        break;
    }
  }
  get canFinish() {
    return this.userService.permissions.finishCases;
  }

  getDataAbierto(filters: any = { state: 'initial' }) {
    this.loading = true;
    this.alertService.getAlerts().subscribe({
      next: (data: any) => {
        this.loading = false;
        this.reset();
        this.allAlertsAbierto = data;

        this.setData(this.allAlertsAbierto);
      },
    });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }
  getDataAsignado(filters: any = { state: 'proceed' }) {
    this.loading = true;
    this.alertService.getAlerts().subscribe({
      next: (data: any) => {
        this.loading = false;
        this.reset();
        this.allAlertsAsignado = data;

        this.setData(this.allAlertsAsignado);
      },
    });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }
  getDataRechazado(filters: any = { state: 'refused' }) {
    this.loading = true;
    this.alertService.getAlerts().subscribe({
      next: (data: any) => {
        this.loading = false;
        this.reset();
        this.allAlertsRechazado = data;

        this.setData(this.allAlertsRechazado);
      },
    });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }
  getAlertByFilterAbierto(filter: any = {}) {
    filter.state = 'initial';
    this.alertService.getalertByList(filter).subscribe((res) => {
      this.loading = false;
      this.allAlertsAbierto = res;

      this.setData(this.allAlertsAbierto);
    });
  }
  getAlertByFilterAsignado(filter: any = {}) {
    filter.state = 'proceed';

    this.alertService.getalertByList(filter).subscribe((res) => {
      this.loading = false;
      this.allAlertsAsignado = res;
    });
  }
  getAlertByFilterRechazado(filter: any = {}) {
    filter.state = 'refused';

    this.alertService.getalertByList(filter).subscribe((res) => {
      this.loading = false;
      this.allAlertsRechazado = res;
    });
  }
  nothing() {
    console.log('x');
  }

  tobeApproved = [];
  toFinalize = [];
  pending = [];
  initial: ICase[] = [];
  running = [];

  showInitialData = false;
  showFinalizeData = false;
  showRunningData = false;
  showPendingData = false;
  showApprovedData = false;

  get countRunning() {
    return this.running?.length;
  }
  get countInitial() {
    return this.initial?.length;
  }
  get countApproved() {
    return this.tobeApproved?.length;
  }
  get countFinalize() {
    return this.toFinalize?.length;
  }
  get countPending() {
    return this.pending?.length;
  }

  //////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  tobeApprovedFillter = [];
  toFinalizeFillter = [];
  pendingFillter = [];
  initialFillter = [];
  runningFillter = [];
  // async orderByFilter(fil, status) {
  //   // if (fil.date) {
  //   //   sort = this[status].sort(function (a, b) {
  //   //     return new Date(a).getTime() - new Date(b).getTime();
  //   //   });
  //   // }
  //   switch (status) {
  //     case 'initial':
  //       this[status + 'Filter'] = fil;
  //       break;
  //     case 'tobeApproved':
  //       this[status + 'Filter'] = fil;
  //       break;
  //     case 'pending':
  //       this[status + 'Filter'] = fil;
  //       break;
  //     case 'running':
  //       this[status + 'Filter'] = fil;
  //       break;
  //     case 'initial':
  //       this[status + 'Filter'] = fil;
  //       break;
  //   }
  //   await this.casesService.getDataByUnitFilter(this.unitId, {}).subscribe({
  //     next: (data: any) => {
  //       this.loading = false;
  //       this[status] = data[status];
  //       //si tiene analista
  //       if (fil.analist) {
  //         this[status] = this[status].filter((r) => {
  //           return r.assigned._id == fil.analist;
  //         });
  //       }
  //       if (fil.caseType) {
  //         this[status] = this[status].filter((r) => {
  //           return r.caseType._id == fil.caseType;
  //         });
  //       }
  //       if (fil.date && fil.date != null) {
  //         this[status] = this[status]
  //           .slice()
  //           .sort(
  //             (a, b) =>
  //               new Date(b.createdAt).getTime() -
  //               new Date(a.createdAt).getTime()
  //           );
  //       }
  //       if (!fil.date && fil.date != null) {
  //         this[status] = this[status]
  //           .slice()
  //           .sort(
  //             (a, b) =>
  //               new Date(a.createdAt).getTime() -
  //               new Date(b.createdAt).getTime()
  //           );
  //       }
  //     },
  //   });
  // }

  users: IUser[] = [];
  caseTypes: ICaseType[] = [];

  getCaseTypes() {
    this.unitService.getTypeCases(this.unitId).subscribe({
      next: (caseTypes) => {
        this.caseTypes = caseTypes;
        this.findUser();
      },
    });
  }
  findUser() {
    for (let caseType of this.caseTypes) {
      this.userService.getUsersByRole(caseType.role).subscribe({
        next: (users: any) => {
          this.users = [...this.users, ...users];
          const uniqueIds = new Set();

          this.users = this.users.filter((element) => {
            const isDuplicate = uniqueIds.has(element._id);

            uniqueIds.add(element._id);

            if (!isDuplicate) {
              return true;
            }

            return false;
          });
        },
      });
    }
  }

  approval(icase) {
    this.dialog
      .open(ConfirmComponent, {
        data: {
          title: '¿Deseas aprobar este caso?',
          type: null,
          approbvalStatus: icase.approvalStatus,
        },
        minWidth: '400px',
      })
      .afterClosed()
      .subscribe(async (response) => {
        if (response) {
          this.caseService.acceptApproval(icase._id).subscribe({
            next: async (updatedCase: any) => {
              const c = await this.getCaso(icase._id);
              await this.updateAlert(c);
              this.alert('El caso ha sido aprobado');

              const remitInstructions: any = c.caseType.remitTo;
              const shouldRemit =
                remitInstructions &&
                remitInstructions.some(
                  (instruction) => instruction.remitIf === 'approved'
                );

              if (shouldRemit) {
                this.remitTo(c);
                return;
              }

              this.generateTasks(icase);
            },
          });
        }
      });
  }
  async getCaso(id) {
    const icase = await this.caseService.getCase(id).pipe(first()).toPromise();
    return icase;
  }
  async remitTo(icase) {
    if (!icase.caseType.remitTo || icase.caseType.remitTo.length === 0) {
      console.error(
        'remitTo fue llamado, pero no se encontraron instrucciones de remisión.'
      );
      return;
    }

    const approvedDestinations = icase.caseType.remitTo.filter(
      (instruction) => instruction.remitIf === 'approved'
    );

    if (approvedDestinations.length === 0) {
      console.warn(
        "remitTo fue llamado, pero ninguna instrucción coincidía con 'approved'."
      );
      return;
    }

    this.dialog
      .open(RemitCaseComponent, {
        width: '600px',
        maxHeight: '80vh',
        data: {
          case: icase,
          destinations: approvedDestinations,
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (remittalSucceeded: boolean) => {
          if (remittalSucceeded) {
            this.generateTasks(icase);
          }
        },
      });
  }
  finishCase(icase) {
    const { caseType } = icase;
    if (!caseType.remitTo || caseType.remitIf != 'finished')
      return this.finish(icase);
    this.dialog
      .open(RemitCaseComponent, {
        width: '600px',
        maxHeight: '80vh',
        data: icase,
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (response) => {
          this.finish(icase);
        },
      });
  }

  finish(icase) {
    let appUnif: any;
    let secondAp = false;
    let controlRas;
    if (
      icase.caseType.approvalRoles?.levelTwo &&
      icase.approvalStatus == 'approved'
    ) {
      appUnif = icase?.apUnif;
    } else {
      appUnif = false;
    }

    if (icase?.caseType.approvalRoles?.levelTwo) secondAp = true;
    if (
      icase.caseType.approvalRoles?.levelTwo &&
      icase.approvalStatus == 'approved'
    ) {
      controlRas = icase?.numberRas ? true : false;
    } else {
      controlRas = false;
    }

    if (!appUnif && secondAp) {
      return this.alert('El caso no ha sido aprobado por UNIF');
    }
    if (!controlRas && secondAp) {
      return this.alert('El caso no posee Número de control RAS');
    }
    this.dialog
      .open(FinishCaseComponent, {
        width: '800px',
        maxHeight: '80vh',
        data: icase,
      })
      .afterClosed()
      .subscribe({
        next: (response) => {
          this.getAlertByFilterAbierto();
          this.getAlertByFilterAsignado();
          this.getAlertByFilterRechazado();
        },
      });
  }

  canControlRas(icase) {
    try {
      const { approvalRoles } = icase?.caseType;
      const { approvalStatus } = icase;
      const roleId = this.userService.currentUser.role._id;
      if (
        approvalRoles?.levelOne == roleId &&
        approvalStatus == 'approved' &&
        icase.caseType.name == 'RAS'
      ) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }
  controlRas(icase) {
    if (
      icase.caseType.approvalRoles?.levelTwo &&
      icase.approvalStatus == 'approved'
    ) {
      return icase?.numberRas ? true : false;
    } else {
      return false;
    }
  }
  async addNumberRas(icase) {
    this.dialog
      .open(RasNumberComponent, {
        minWidth: '400px',
      })
      .afterClosed()
      .subscribe(async (re) => {
        if (re.status) {
          await this.caseService
            .update(icase._id, {
              numberRas: re.value.num,
              desRas: re.value.observation,
            })
            .subscribe((caseUpdated) => {
              icase = caseUpdated;
              this.getAlertByFilterAbierto();
              this.getAlertByFilterAsignado();
              this.getAlertByFilterRechazado();
              // this.caseService.caseEdited.next(this.case);
            });
        }
      });
  }
  generateTasks(icase) {
    if (icase.caseType.generateTasks.length > 0) {
      this.dialog.open(GenerateTasksComponent, {
        width: '900px',
        maxHeight: '80vh',
        data: {
          case: icase._id,
          caseType: icase.caseType._id,
        },
        disableClose: true,
      });
    }
  }
  updateAlert(icase) {
    let index: any;
    switch (icase.status) {
      case 'initial':
        index = this.allAlertsAbierto.findIndex(
          (item) => item._id == icase._id
        );
        this.allAlertsAbierto.splice(index, 1, icase);
        this.setData(this.allAlertsAbierto);
        this.casesContentNewViewComponent.table.renderRows();
        break;
      case 'proceed':
        index = this.allAlertsAsignado.findIndex(
          (item) => item._id == icase._id
        );
        this.allAlertsAsignado.splice(index, 1, icase);
        this.setData(this.allAlertsAsignado);
        this.casesContentNewViewComponent.table.renderRows();
        break;
      case 'refused':
        index = this.allAlertsRechazado.findIndex(
          (item) => item._id == icase._id
        );
        this.allAlertsRechazado.splice(index, 1, icase);
        this.setData(this.allAlertsRechazado);
        this.casesContentNewViewComponent.table.renderRows();
        break;
      default:
        break;
    }
  }

  needApproval(icase) {
    try {
      const { approvalRoles } = icase?.caseType;
      const { approvalStatus } = icase;
      const roleId = this.userService.currentUser.role._id;
      if (
        approvalRoles?.levelOne == roleId &&
        approvalStatus == 'requestLevelOne'
      ) {
        return true;
      }
      if (
        approvalRoles?.levelTwo == roleId &&
        approvalStatus == 'requestLevelTwo'
      ) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }
  valueTab = 0;
  change(value) {
    this.valueTab = value;

    switch (value) {
      case 0:
        this.setData(this.allAlertsAbierto);

        break;
      case 1:
        this.setData(this.allAlertsAsignado);
        break;
      case 2:
        this.setData(this.allAlertsRechazado);
        break;
      default:
        break;
    }
    this.casesContentNewViewComponent.table.renderRows();
  }

  // openBtCaseModal() {
  //   this.dialog.open(CreateBtCaseComponent, {
  //     width: '90%',
  //     data: {
  //       /* opcional */
  //     },
  //   });
  // }
}
